import { useState } from "react";
import { faPen } from "@fortawesome/pro-solid-svg-icons/faPen";
import { faXmarkLarge } from "@fortawesome/pro-solid-svg-icons/faXmarkLarge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "@onefront/react-sdk";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  TextField,
  Tooltip,
} from "@vapor/react-material";
import Typography from "@vapor/react-extended/ExtendedTypography";

import * as React from "react";
import { usePatchToRenameFile } from "../hooks/usePatchToRenameFile";

export default function RenameDocumentFileModal({
  workspaceId,
  id,
  setReload,
  data: docData,
  setNewName,
  newName,
}) {
  const { t } = useTranslation("DOCS");
  const [open, setOpen] = useState(false);
  const [newFileName, setNewFileName] = useState(docData?.fileName);
  const [errorField, setErrorField] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const { data, loading, error, fetch } = usePatchToRenameFile({
    id,
    newFileName,
    workspaceId,
  });

  if (data) {
    setNewName(newFileName);
  }

  const inputController = (e) => {
    if (e.includes(".")) {
      setErrorField(true);
      setErrorMessage(
        "Invalid file name format. File names cannot contain dots (.) or change document format."
      );
    }

    const filenamePattern = "^[a-zA-Z0-9 _\\-()]{1,200}$";

    const regex = new RegExp(filenamePattern);

    if (!regex.test(e)) {
      setErrorField(true);
      setErrorMessage(
        "Invalid file name format. Please use only alphanumeric characters and parentheses."
      );
    } else if (e === "") {
      setErrorField(true);
      setErrorMessage(t("document.renameErrorMessage"));
    } else {
      // If no errors, update the file name (but without extension)
      const extension = docData?.fileName.split(".").pop(); // Get the original extension
      setErrorField(false);
      setNewFileName(e + (extension ? "." + extension : ""));
    }
  };

  return (
    <div>
      <Tooltip arrow title={t("classification.rename")} placement="top">
        <IconButton onClick={handleClickOpen} color="primary" size="small">
          <FontAwesomeIcon icon={faPen} />
        </IconButton>
      </Tooltip>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle style={{ display: "flex" }} id="alert-dialog-title">
          <Typography>{t("classification.rename")}</Typography>
          <IconButton size="medium" color="primary">
            <FontAwesomeIcon icon={faXmarkLarge} onClick={handleClose} />
          </IconButton>
        </DialogTitle>
        <Divider variant="fullWidth" />
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box
              sx={{
                width: 500,
                maxWidth: "100%",
              }}
            >
              <TextField
                defaultValue={
                  newFileName
                    ? newFileName.split(".")[0]
                    : docData?.fileName.split(".")[0]
                }
                onChange={(e) => inputController(e.target.value)}
                fullWidth
                id="fullWidth"
                error={errorField}
                helperText={errorField && errorMessage}
              />
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={handleClose}>
            {t("classification.cancel")}
          </Button>
          <Button
            disabled={errorField}
            variant="contained"
            onClick={async () => {
              await setOpen(false);
              await fetch();
            }}
            autoFocus
          >
            {t("chat.save")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
